export default "__VITE_ASSET__CKLlngzT__"